import { useAuthUser } from '@/hooks';
import useIsIframe from '@/hooks/useIsIframe';
import { getExternalServiceUrl } from '@/utils/environment';
import { useTranslation } from 'react-i18next';

import styles from './OmniSwitchBanner.module.css';

export function OmniSwitchBanner() {
  const { t } = useTranslation();
  const user = useAuthUser();
  const isIframe = useIsIframe();

  if (isIframe) {
    return null;
  }

  if (!user?.is_client) {
    return null;
  }

  const handleOpenOmni = () => {
    if (typeof window === 'undefined') {
      return;
    }
    const omniOrigin = getExternalServiceUrl('omni');
    // The campaigns area in beatly-web-app does not have a 1:1 equivalent in omni,
    // so send users to the omni landing page (root) instead of preserving the path.
    const isCampaignsArea = /^\/connect\/campaigns(\/|$)/.test(window.location.pathname);
    const dest = isCampaignsArea
      ? `${omniOrigin}/`
      : `${omniOrigin}${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.assign(dest);
  };

  return (
    <div className={styles.banner} data-testid="omni-switch-banner" role="region">
      <div className={styles.accent} aria-hidden="true" />
      <div className={styles.inner}>
        <div className={styles.textColumn}>
          <span className={styles.title}>{t('omniSwitchBanner.title')}</span>
          <span className={styles.subtitle}>{t('omniSwitchBanner.subtitle')}</span>
        </div>
        <button
          type="button"
          className={styles.cta}
          onClick={handleOpenOmni}
          aria-label={t('omniSwitchBanner.ariaLabel')}
        >
          {t('omniSwitchBanner.cta')}
          <span className={styles.arrow} aria-hidden="true">
            →
          </span>
        </button>
      </div>
    </div>
  );
}
